export default __webpack_public_path__ + "static/customer-portal-fallback-image-b808e32d918f26c37d20d1928438c607.jpg";